export default "__VITE_ASSET__rkDpT8vl__"